import React from 'react';
import {useTeam} from '../context/TeamContext';
import {useAuth} from '../context/AuthContext';
import TeamAppearanceRuntime from './TeamAppearanceRuntime';
export default function WebTeamAppearance(){
  const {teamId}=useTeam();const {userData}=useAuth();
  return <TeamAppearanceRuntime teamId={teamId} uid={userData?.uid}/>;
}
